import { set } from 'cerebral/operators'

export default [set('state:client.forms.snackbar.show', false)]



// WEBPACK FOOTER //
// ./src/modules/user/chains/unShowSaveUserSnackbar.js